export enum ToolType {
  DEFAULT = "default",
  WOODEN = "wooden",
  STEEL = "steel",
  TITANIUM = "titanium",
  DIAMOND = "diamond"
}
